import React from "react";

interface PricingCardProps {
	name: string;
	price: string;
	period?: string;
	description: string;
	features: string[];
	highlighted?: boolean;
	badge?: string;
	cta: string;
	ctaHref?: string;
}

export function PricingCard({
	name,
	price,
	period = "/mo",
	description,
	features,
	highlighted = false,
	badge,
	cta,
	ctaHref = "/signup",
}: PricingCardProps) {
	return (
		<div
			className={`relative flex flex-col rounded-2xl p-6 ${
				highlighted
					? "border-2 border-[#db241e]/40 bg-[#db241e]/5 shadow-lg shadow-red-900/10"
					: "border border-white/10 bg-white/[0.02]"
			}`}
		>
			{badge && (
				<span className="absolute -top-3 left-1/2 -translate-x-1/2 rounded-full bg-[#db241e] px-3 py-0.5 text-xs font-semibold text-white">
					{badge}
				</span>
			)}

			<div className="mb-6">
				<h3 className="text-lg font-semibold text-white">{name}</h3>
				<div className="mt-2 flex items-baseline gap-1">
					<span className="text-4xl font-bold text-white">{price}</span>
					{price !== "Custom" && (
						<span className="text-sm text-zinc-500">{period}</span>
					)}
				</div>
				<p className="mt-2 text-sm text-zinc-400">{description}</p>
			</div>

			<ul className="mb-8 flex-1 space-y-3">
				{features.map((feat) => (
					<li key={feat} className="flex items-start gap-2 text-sm text-zinc-300">
						<svg
							className="mt-0.5 h-4 w-4 shrink-0 text-[#db241e]"
							fill="none"
							viewBox="0 0 24 24"
							stroke="currentColor"
							strokeWidth={2.5}
						>
							<path
								strokeLinecap="round"
								strokeLinejoin="round"
								d="M5 13l4 4L19 7"
							/>
						</svg>
						{feat}
					</li>
				))}
			</ul>

			<a
				href={ctaHref}
				className={`block rounded-lg py-2.5 text-center text-sm font-medium transition-all ${
					highlighted
						? "bg-[#db241e] text-white hover:bg-[#c41f1a] hover:shadow-lg hover:shadow-red-900/30"
						: "border border-white/10 bg-white/5 text-zinc-300 hover:border-white/20 hover:bg-white/10"
				}`}
			>
				{cta}
			</a>
		</div>
	);
}
